var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import dayjs from 'dayjs';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import { AppContext } from '../../hooks/context';
import { Button, ModalUpdate2, SelectsMain, Students } from '../../components';
import { useHttp } from '../../hooks/useHttp';
import AllStudentsRegister from '../AllStudentsRegister/AllStudentsRegister';
const MainPage = () => {
    const { t } = useTranslation();
    const { request } = useHttp();
    const [isTime, setIsTime] = React.useState('');
    const time = dayjs(new Date()).format('YYYY-MM-DD');
    const { user, setAuth, auth, login } = React.useContext(AppContext);
    const [isAlert, setIsAlert] = React.useState(false);
    const [modal, setModal] = React.useState(false);
    const [modal2, setModal2] = React.useState(false);
    const [faculties, setFaculties] = React.useState([]);
    const [years, setYears] = React.useState([]);
    const [rate, setRate] = React.useState([]);
    const [kafedra, setKafedra] = React.useState([]);
    const [teachers, setTeachers] = React.useState([]);
    const [ws, setWs] = React.useState([]);
    const [discipline, setDiscipline] = React.useState([]);
    const [formControl, setFormControl] = React.useState([]);
    const [group, setGroup] = React.useState([]);
    const [flows, setFlows] = React.useState([]);
    const [students, setStudents] = React.useState([]);
    const [disciplineOne, setDisciplineOne] = React.useState([]);
    // const [allTeachers, setAllTeachers] = React.useState<IAllTeachers[]>([])
    const [studentsFlow, setStudentsFlow] = React.useState([]);
    const [loaderStudent, setLoaderStudent] = React.useState(false);
    const [loaderModal2, setLoaderModal2] = React.useState(true);
    const [formLear, setFormLearn] = React.useState('');
    const [groupNum, setGroupNum] = React.useState(null);
    const [idSemester, setIdSemester] = React.useState(null);
    const [idDisciplineForStudent, setIdDisciplineForStudent] = React.useState(null);
    const [handleStudentLoader, setHandleStudentLoader] = React.useState(false);
    const [idVidDiscipline, setIdVidDiscipline] = React.useState(null);
    const [flow, setFlow] = React.useState(null);
    const [credit, setCredit] = React.useState();
    const [idStudent, setIdStudent] = React.useState(null);
    const [isPage, setIsPage] = React.useState(false);
    const [formSelect, setFormSelect] = React.useState({
        faculty: '',
        discipline: '',
        year: '',
        kafedra: '',
        teachers: '',
        formControl: '',
        group: '',
        ws: '',
        rate: '',
        rowNum: '',
    });
    const changeFaculties = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { faculty: Number(e.target.value), group: '', teachers: '', discipline: '', rowNum: '', formControl: '', kafedra: '' }));
        if (kafedra.length) {
            setKafedra([]);
        }
        getKafedra(e.target.value);
        if (teachers.length) {
            setTeachers([]);
        }
        if (rate.length) {
            setRate([]);
        }
        if (discipline.length) {
            setDiscipline([]);
        }
        if (formControl.length) {
            setFormControl([]);
        }
        if (group.length) {
            setGroup([]);
        }
        if (formLear) {
            setFormLearn('');
        }
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeYear = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { year: Number(e.target.value), group: '', teachers: '', discipline: '', rowNum: '', ws: '', formControl: '', kafedra: '', rate: '' }));
        if (kafedra.length) {
            setKafedra([]);
        }
        if (ws.length) {
            setWs([]);
        }
        getWs();
        if (rate.length) {
            setRate([]);
        }
        // getKafedra(e.target.value)
        if (teachers.length) {
            setTeachers([]);
        }
        if (discipline.length) {
            setDiscipline([]);
        }
        if (formControl.length) {
            setFormControl([]);
        }
        if (group.length) {
            setGroup([]);
        }
        if (formLear) {
            setFormLearn('');
        }
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeKafedra = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { kafedra: Number(e.target.value), group: '', teachers: '', discipline: '', rowNum: '', formControl: '', rate: '' }));
        if (teachers.length) {
            setTeachers([]);
        }
        getTeachers(e.target.value);
        if (rate.length) {
            setRate([]);
        }
        if (discipline.length) {
            setDiscipline([]);
        }
        if (formControl.length) {
            setFormControl([]);
        }
        if (group.length) {
            setGroup([]);
        }
        if (formLear) {
            setFormLearn('');
        }
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeTeacher = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { teachers: Number(e.target.value), group: '', discipline: '', rowNum: '', formControl: '', rate: '' }));
        if (discipline.length) {
            setDiscipline([]);
        }
        getDiscipline(e.target.value);
        if (rate.length) {
            setRate([]);
        }
        if (formControl.length) {
            setFormControl([]);
        }
        if (group.length) {
            setGroup([]);
        }
        if (formLear) {
            setFormLearn('');
        }
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeWs = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { ws: Number(e.target.value), group: '', discipline: '', rowNum: '', formControl: '', rate: '', faculty: '', kafedra: '', teachers: '' }));
        getFaculties();
        if (discipline.length) {
            setDiscipline([]);
        }
        // getDiscipline(formSelect.ws)
        if (formControl.length) {
            setFormControl([]);
        }
        if (group.length) {
            setGroup([]);
        }
        if (rate.length) {
            setRate([]);
        }
        if (formLear) {
            setFormLearn('');
        }
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeDiscipline = (e) => {
        const i = discipline.find((item) => item.rowNum == e.target.value);
        setCredit(i === null || i === void 0 ? void 0 : i.Krdt);
        setFormSelect(Object.assign(Object.assign({}, formSelect), { 
            // @ts-ignore
            discipline: i === null || i === void 0 ? void 0 : i.id_discipline, group: '', formControl: '', rate: '', rowNum: e.target.value }));
        if (formControl.length) {
            setFormControl([]);
        }
        getFormControl(i === null || i === void 0 ? void 0 : i.id_discipline);
        if (group.length) {
            setGroup([]);
        }
        if (rate.length) {
            setRate([]);
        }
        if (formLear) {
            setFormLearn('');
        }
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeFormControl = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { formControl: e.target.value, group: '', rate: '' }));
        if (group.length) {
            setGroup([]);
        }
        if (rate.length) {
            setRate([]);
        }
        geteRate();
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeRate = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { rate: e.target.value }));
        getGroup(e.target.value);
        if (formLear) {
            setFormLearn('');
        }
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
    };
    const changeGroup = (e) => {
        setFormSelect(Object.assign(Object.assign({}, formSelect), { group: e.target.value }));
        if (flows.length) {
            setFlows([]);
        }
        if (students.length) {
            setStudents([]);
        }
        if (studentsFlow.length) {
            setStudentsFlow([]);
        }
        if (idVidDiscipline) {
            setIdVidDiscipline(null);
        }
        getFlowsAndStudents(e.target.value);
    };
    const changeFlow = (e) => {
        getStudentsFlowPotok(e.target.value);
        getIdVidDiscipline(e.target.value);
        setFlow(e.target.value);
    };
    const getFaculties = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield request(`/faculties/${auth === null || auth === void 0 ? void 0 : auth.id_avn_user}`);
        setFaculties(res.data);
        if (!res.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
    });
    const getYears = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield request('/years');
        const { data } = yield request('/years/default');
        if (!res.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        setFormSelect(Object.assign(Object.assign({}, formSelect), { year: data.id_a_year }));
        setYears(res.data);
    });
    const geteRate = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield request('/rate');
        setRate(data);
    });
    const getKafedra = (faculty_) => __awaiter(void 0, void 0, void 0, function* () {
        const { data, auth } = yield request(`/kafedra?id_year=${formSelect.year}&id_ws=${formSelect.ws}&id_faculty=${faculty_}`);
        setKafedra(data);
        if (!auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
    });
    const getTeachers = (id_kafedra) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield request(`/teachers?id_year=${formSelect.year}&id_kafedra=${id_kafedra}&id_faculty=${formSelect.faculty}&id_ws=${formSelect.ws}`);
        setTeachers(res.data);
        if (!res.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
    });
    const getWs = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data, auth } = yield request('/ws');
        if (!auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        // setFormSelect({ ...formSelect, ws: data[0]?.defaultValue })
        setWs(data);
    });
    const getDiscipline = (id_teacher) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield request(`/discipline?id_year=${formSelect.year}&id_kafedra=${formSelect.kafedra}&id_teacher=${id_teacher}&id_w_s=${formSelect.ws}&id_faculty=${formSelect.faculty}`);
        setDiscipline(res.data);
        if (!res.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
    });
    const getFormControl = (id_discipline) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield request(`/form-control?id_year=${formSelect.year}&id_kafedra=${formSelect.kafedra}&id_teacher=${formSelect.teachers}&id_w_s=${formSelect.ws}&id_discipline=${id_discipline}`);
        setFormControl(res.data);
        if (!res.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
    });
    const getGroup = (id_rate) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield request(`/group?id_year=${formSelect.year}&id_w_s=${formSelect.ws}&id_faculty=${formSelect.faculty}&rate=${id_rate}`);
        if (!res.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        setGroup(res.data);
    });
    const getStudents = (id_group) => __awaiter(void 0, void 0, void 0, function* () {
        // const resStudents: IResStudent = await request(
        //     `/students?id_group=${id_group}&id_discipline=${formSelect.discipline}&id_year=${formSelect.year}&id_examination=${formSelect.formControl}&id_w_s=${formSelect.ws}&kredit=${credit}&id_user=${user?.id_AVN_user} `,
        // )
        const resStudents = yield request('/students', 'POST', {
            id_group,
            id_discipline: formSelect.discipline,
            id_year: formSelect.year,
            id_examination: formSelect.formControl,
            id_w_s: formSelect.ws,
            kredit: credit,
            id_user: auth === null || auth === void 0 ? void 0 : auth.id_avn_user,
        });
        if (!resStudents.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        setStudents(resStudents.data);
    });
    const getStudentsFlowPotok = (flow_) => __awaiter(void 0, void 0, void 0, function* () {
        // const resStudentsFlow: IResStudentFlow = await request(
        //     `/students-flow-potok?id_discipline=${formSelect.discipline}&id_year=${formSelect.year}&id_examination=${formSelect.formControl}&id_w_s=${formSelect.ws}&kredit=${credit}&id_teacher=${formSelect.teachers}&flow=${flow_}`,
        // )
        const resStudentsFlow = yield request('/students-flow-potok', 'POST', {
            id_discipline: formSelect.discipline,
            id_year: formSelect.year,
            id_examination: formSelect.formControl,
            id_w_s: formSelect.ws,
            kredit: credit,
            id_teacher: formSelect.teachers,
            flow: flow_,
        });
        if (!resStudentsFlow.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        setStudentsFlow(resStudentsFlow.data);
    });
    const getFlowsAndStudents = (id_group) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const a = group.find((item) => item.id_group == Number(id_group));
        setLoaderStudent(true);
        const resIdSemester = yield request(`/semester/id?id_year=${formSelect.year}&id_group=${id_group}&id_w_s=${formSelect.ws}`);
        const resFlows = yield request(`/flow?id_discipline=${formSelect.discipline}&id_year=${formSelect.year}&id_examination=${formSelect.formControl}&id_w_s=${formSelect.ws}&id_kafedra=${formSelect.kafedra}&id_teacher=${formSelect.teachers}&kredit=${credit}&id_f_educ=${a === null || a === void 0 ? void 0 : a.id_f_educ}&id_faculty=${formSelect.faculty}`);
        const resGroupNum = yield request(`/group-num?id_discipline=${formSelect.discipline}&id_year=${formSelect.year}&id_examination=${formSelect.formControl}&id_w_s=${formSelect.ws}&id_kafedra=${formSelect.kafedra}&id_group=${id_group}`);
        const resTime = yield request(`/time?id_year=${formSelect.year}&id_w_s=${formSelect.ws}&id_group=${id_group}`);
        const resFormLearn = yield request(`/learn/${id_group}`);
        if (!resGroupNum.auth || !resIdSemester.auth || !resFlows.auth || !resTime.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        yield getStudents(id_group);
        if (resFlows.data.length) {
            yield getStudentsFlowPotok((_a = resFlows.data[0]) === null || _a === void 0 ? void 0 : _a.subgroup);
        }
        setFormLearn((_b = resFormLearn.data) === null || _b === void 0 ? void 0 : _b.p108);
        setIsTime(dayjs((_c = resTime.data) === null || _c === void 0 ? void 0 : _c.endDate).format('YYYY-MM-DD'));
        setIdSemester(resIdSemester.data.id_semester);
        setFlows(resFlows.data);
        setFlow((_d = resFlows.data[0]) === null || _d === void 0 ? void 0 : _d.subgroup);
        if (resFlows.data.length) {
            getIdVidDiscipline((_e = resFlows.data[0]) === null || _e === void 0 ? void 0 : _e.subgroup);
        }
        setGroupNum(resGroupNum.data.descGroupNum);
        setLoaderStudent(false);
    });
    const handleStudentsDiscipline = (arrIdStudents) => __awaiter(void 0, void 0, void 0, function* () {
        if (time < isTime) {
            // @ts-ignore
            const f = flows.find((item) => item.subgroup == Number(flow));
            setHandleStudentLoader(true);
            setStudents([]);
            const { data, type, auth, message } = yield request('/student-discipline', 'POST', {
                id_discipline: formSelect.discipline,
                id_year: formSelect.year,
                id_examination: Number(formSelect.formControl),
                id_semester: idSemester,
                id_kafedra: formSelect.kafedra,
                id_group: Number(formSelect.group),
                id_student: arrIdStudents,
                id_ws: formSelect.ws,
                groupNum: groupNum,
                id_teacher: formSelect.teachers,
                flow: Number(flow),
                AVN_login: login,
                id_faculty: formSelect.faculty,
                kredit: credit,
                id_vid_zaniatiy: idVidDiscipline,
            });
            if ((f === null || f === void 0 ? void 0 : f.kolStud) < arrIdStudents.length + studentsFlow.length) {
                toast.warn(t('limitRegister'));
            }
            if (!auth) {
                setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
                return;
            }
            setHandleStudentLoader(false);
            yield getStudents(String(formSelect.group));
            yield getStudentsFlowPotok(flow);
            toast[type](message);
            return;
        }
        toast.warn(t('term'));
    });
    const getIdVidDiscipline = (flow) => __awaiter(void 0, void 0, void 0, function* () {
        const { data, auth } = yield request(`/id-discipline?id_discipline=${formSelect.discipline}&id_year=${formSelect.year}&id_examination=${formSelect.formControl}&id_w_s=${formSelect.ws}&id_kafedra=${formSelect.kafedra}&id_teacher=${formSelect.teachers}&flow=${flow}`);
        if (!auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        setIdVidDiscipline(data.id_vid_zaniatiy);
    });
    const showAlert = () => {
        if (time < isTime) {
            return setIsAlert(true);
        }
        toast.warn(t('term'));
    };
    const showModal = () => {
        document.body.style.overflowY = 'hidden';
        // setIdDisciplineForStudent(id)
        setModal(true);
    };
    const hideModal = () => {
        document.body.style.overflowY = 'visible';
        setModal(false);
    };
    const hideAlert = () => {
        setIsAlert(false);
    };
    const showModal2 = (id_student) => {
        document.body.style.overflowY = 'hidden';
        setModal2(true);
        setIdStudent(id_student);
        getDisciplineOneAndAllTeacher(id_student);
    };
    const hideModal2 = () => {
        document.body.style.overflowY = 'visible';
        setModal2(false);
    };
    const getDisciplineOneAndAllTeacher = (id_student) => __awaiter(void 0, void 0, void 0, function* () {
        // setLoaderModal2(true)
        const resDisciplineOne = yield request(`/discipline/one?id_student=${id_student}&id_semester=${idSemester}&id_year=${formSelect.year}&id_discipline=${formSelect.discipline}&id_group=${formSelect.group}&groupNum=${groupNum}&kredit=${credit}`);
        // const resAllTeacher: IResAllTeachers = await request(`/all-teachers?id_kafedra=${formSelect.kafedra}`)
        // if (!resDisciplineOne.auth || !resAllTeacher.auth) {
        //     setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null
        //     return
        // }
        // setAllTeachers(resAllTeacher.data)
        setDisciplineOne(resDisciplineOne.data);
        setLoaderModal2(false);
    });
    const deleteDisciplineApi = (id_) => __awaiter(void 0, void 0, void 0, function* () {
        if (time < isTime) {
            setIsAlert(false);
            setLoaderStudent(true);
            const { data, type, auth: isAuth, message, } = yield request(`/students/discipline-delete/${auth === null || auth === void 0 ? void 0 : auth.id_avn_user}`, 'POST', {
                id: id_,
            });
            toast[type](message);
            if (!isAuth) {
                setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
                return;
            }
            yield getStudents(String(formSelect.group));
            yield getStudentsFlowPotok(flow);
            return setLoaderStudent(false);
        }
        toast.warn(t('term'));
    });
    const updateDiscipline = (flow_, id_teacher, ids) => __awaiter(void 0, void 0, void 0, function* () {
        if (time < isTime) {
            document.body.style.overflowY = 'visible';
            setModal(false);
            setLoaderStudent(true);
            const { data, type, auth, message } = yield request(`/students/discipline`, 'PUT', {
                flow: flow_,
                id_teacher,
                ids,
            });
            if (!auth) {
                setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
                return;
            }
            toast[type](message);
            yield getStudents(String(formSelect.group));
            if (flow_.length) {
                yield getStudentsFlowPotok(flow);
            }
            setLoaderStudent(false);
            return;
        }
        toast.warn(t('term'));
    });
    const updateTeacher = (id_teacher_, flow_, kafedra_) => __awaiter(void 0, void 0, void 0, function* () {
        if (time < isTime) {
            document.body.style.overflowY = 'visible';
            setModal2(false);
            setLoaderStudent(true);
            const { data, type, auth, message } = yield request('/students/teacher', 'PUT', {
                id_discipline: Number(formSelect.discipline),
                id_year: Number(formSelect.year),
                id_examination: Number(formSelect.formControl),
                id_semester: idSemester,
                id_student: idStudent,
                id_kafedra: Number(kafedra_),
                groupNum: groupNum,
                id_teacher: Number(id_teacher_),
                flow: Number(flow_),
                id_ws: formSelect.ws
            });
            if (!auth) {
                setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
                return;
            }
            toast[type](message);
            yield getStudents(String(formSelect.group));
            yield getStudentsFlowPotok(flow);
            setLoaderStudent(false);
            return;
        }
        toast.warn(t('term'));
    });
    React.useEffect(() => {
        if (auth === null || auth === void 0 ? void 0 : auth.id_avn_user) {
            getYears();
            getWs();
        }
    }, [user]);
    const reload = () => {
        window.location.reload();
    };
    if (isPage) {
        return _jsx(AllStudentsRegister, { formSelect: formSelect, credit: credit, setIsPage: setIsPage });
    }
    return (_jsxs(_Fragment, { children: [modal2 && (_jsx(ModalUpdate2, { groups: group, credit: credit, idSemester: idSemester, formSelect: formSelect, loaderModal2: loaderModal2, disciplineOne: disciplineOne, hideModal: hideModal2, updateTeacher: updateTeacher })), _jsxs("div", Object.assign({ className: styles.container }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between" }, { children: [(user === null || user === void 0 ? void 0 : user.access) && (_jsx(NavLink, Object.assign({ to: "/avn33/remove" }, { children: _jsxs("button", Object.assign({ className: "btn btn-danger" }, { children: [_jsx("i", { style: { marginRight: '8px' }, className: "fa-solid fa-eraser" }), t('deleteRegister')] })) }))), _jsx("div", Object.assign({ style: { width: '211px' } }, { children: _jsx("a", Object.assign({ href: "/avn33/dock/manual.pdf", target: "_blank" }, { children: _jsx(Button, { value: t('manual'), icon: _jsx("i", { className: "fa-solid fa-file-invoice" }) }) })) })), _jsx("div", Object.assign({ style: { width: '211px' } }, { children: _jsx(Button, { value: t('reload'), type: "btn-success", onClick: reload, icon: _jsx("i", { className: "fa-solid fa-rotate-right" }) }) }))] })), _jsx(SelectsMain, { rate: rate, group: group, years: years, kafedra: kafedra, teachers: teachers, formLear: formLear, ws: ws, faculties: faculties, discipline: discipline, formSelect: formSelect, formControl: formControl, changeRate: changeRate, changeYear: changeYear, changeGroup: changeGroup, changeKafedra: changeKafedra, changeTeacher: changeTeacher, changeWs: changeWs, changeFaculties: changeFaculties, changeDiscipline: changeDiscipline, changeFormControl: changeFormControl }), _jsx(Students, { formSelect: formSelect, updateDiscipline: updateDiscipline, hideModal: hideModal, idSemester: idSemester, modal: modal, flow: flow, flows: flows, group: group, credit: credit, isAlert: isAlert, students: students, hideAlert: hideAlert, deleteDisciplineApi: deleteDisciplineApi, loader: loaderStudent, studentsFlow: studentsFlow, handleStudentLoader: handleStudentLoader, showAlert: showAlert, showModal: showModal, setIsPage: setIsPage, showModal2: showModal2, changeFlow: changeFlow, handleStudentsDiscipline: handleStudentsDiscipline })] }))] }));
};
export default MainPage;
